/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-03-07 15:23:45
 */
import { defineMessages } from 'react-intl';

const object: { [key: string]: string } = {
  networkCard: '网卡管理',
  name: '名称',
  address: '地址',
  gateway: '网关',
  DNS: 'DNS',
  operate: '操作',
  sending: '发送中',
  receiving: '接收中',
  updateNetwork: '修改网卡信息',
  subMask: '子掩码',
  edit: '修改',
  placeholder: '请输入',
  rules: '格式不正确',
  none: '无',
  pleaseStopSupos: '若需修改IP和子掩码，请先停止supOS',
  tip: '启动或安装NetworkManager后可进行管理',
  confirmTip: '请确认新IP地址{data}正确？',
  emptyText: '找不到任何匹配的内容',
  refresh: '刷新',
};

export default defineMessages(object);
